"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var percentageOptions = [15, 18, 20, 'Custom'];
var _default = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(_default, _React$Component);
  var _super = _createSuper(_default);
  function _default(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, _default);
    _this = _super.call(this, props);
    _this.state = {
      percentage: 18
    };
    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.convertPercentageOfToDecimal = _this.convertPercentageOfToDecimal.bind((0, _assertThisInitialized2["default"])(_this));
    _this.formatPercentageLabel = _this.formatPercentageLabel.bind((0, _assertThisInitialized2["default"])(_this));
    _this.emitTipChange = _this.emitTipChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.emitTipChange();
    }
  }, {
    key: "convertPercentageOfToDecimal",
    value: function convertPercentageOfToDecimal(amount, percentage) {
      return (amount * (percentage / 100)).toFixed(2);
    }
  }, {
    key: "formatPercentageLabel",
    value: function formatPercentageLabel(value) {
      if (value === 'Custom') return 'Custom';
      return "".concat(value, "%");
    }
  }, {
    key: "handlePercentageChange",
    value: function handlePercentageChange(e, _ref) {
      var _this2 = this;
      var value = _ref.value;
      this.setState({
        percentage: value
      }, function () {
        _this2.emitTipChange();
      });
    }
  }, {
    key: "emitTipChange",
    value: function emitTipChange() {
      var percentage = this.state.percentage;
      var _this$props = this.props,
        handleChange = _this$props.handleChange,
        amount = _this$props.amount;
      if (percentage !== 'Custom') {
        var target = {
          id: 'tip',
          name: 'tip',
          value: this.convertPercentageOfToDecimal(amount, percentage)
        };
        var e = {
          target: target
        };
        handleChange(e, target);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        handleChange = _this$props2.handleChange,
        tip = _this$props2.tip;
      var percentage = this.state.percentage;
      return /*#__PURE__*/_react["default"].createElement("div", null, percentageOptions.map(function (percent) {
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Radio, {
          key: percent,
          name: "tip",
          className: "tip-button",
          label: _this3.formatPercentageLabel(percent),
          value: percent,
          onChange: _this3.handlePercentageChange,
          checked: percentage === percent
        });
      }), percentage === 'Custom' && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Input, {
        className: "tip-input",
        label: "$",
        name: "tip",
        id: "tip",
        step: "0.01",
        onChange: handleChange,
        type: "number",
        value: tip
      }));
    }
  }]);
  return _default;
}(_react["default"].Component);
exports["default"] = _default;